import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20af792e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }

import {provide, computed} from "vue";
import FileStore, {key}  from "./components/FileManager";
import SideMenu from "./components/SideMenu.vue";
import  { setupToaster, toastInjectionKey } from "./components/Toaster/ToastManager";
import ToasterView from "./components/Toaster/ToasterView.vue";
import ConfigStore, { configInjectionKey } from "./components/ConfigManager";
import { circuitConfigInjectionKey, defaultCircuits } from "./components/CircuitSelector/CircuitManager";
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const preventDefault = (e:Event)=>{e.preventDefault();}

const pagetitle = computed(()=>{
  const router = useRouter();
  return router.currentRoute.value.name;
})

provide(key, FileStore);
provide(toastInjectionKey, setupToaster(500, 500));
provide(configInjectionKey, ConfigStore);
provide(circuitConfigInjectionKey, defaultCircuits);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "side",
      onDragover: preventDefault,
      onDrop: preventDefault
    }, [
      _createVNode(SideMenu)
    ], 32),
    _createElementVNode("div", {
      class: "main",
      onDragover: preventDefault,
      onDrop: preventDefault
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t(`sidemenu.${String(_unref(pagetitle))}.title`)), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t(`sidemenu.${String(_unref(pagetitle))}.subtitle`)), 1)
      ]),
      _createVNode(_component_router_view)
    ], 32),
    _createVNode(ToasterView)
  ], 64))
}
}

})